import { render, staticRenderFns } from "./AchatFraisList.vue?vue&type=template&id=419fdfa2&"
import script from "./AchatFraisList.vue?vue&type=script&lang=ts&"
export * from "./AchatFraisList.vue?vue&type=script&lang=ts&"
import style0 from "./AchatFraisList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports